<script setup lang="ts">
withDefaults(
  defineProps<{
    errorMessages?: string | string[];
    readonly?: boolean;
    disabled?: boolean;
    hideDetails?: boolean | 'auto';
    label?: string;
    placeholder?: string;
    maskaOption?: Object | null;
    required?: boolean;
  }>(),
  {
    errorMessages: () => [],
    readonly: false,
    disabled: false,
    hideDetails: false,
    label: '',
    placeholder: '',
    maskaOption: null,
    required: false,
  }
);
const text = defineModel<string | number | null>();
</script>
<template>
  <v-text-field
    v-maska="maskaOption"
    v-model="text"
    flat
    variant="solo-filled"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :readonly="readonly"
    :disabled="disabled"
    data-testid="text-field"
  >
    <template #label>
      <span v-if="required">
        {{ label }} <span style="color: #ff0000;">*</span>
      </span>
      <span v-else>{{ label }}</span>
    </template>
    <template #append-inner>
      <slot name="append-inner" />
    </template>
  </v-text-field>
</template>

<style></style>
